import React from "react";
import "./LegalPages.css";

function Termini() {
  return (
    <main className="legal-page">
      <h1>Termini e Condizioni d’Uso</h1>
      <p>
        L’accesso e l’utilizzo del sito web di <strong>B.A.S. D.O.C. SERIANA COBRAS </strong>
        implicano l’accettazione dei seguenti termini e condizioni.
      </p>

      <h2>1. Proprietà dei contenuti</h2>
      <p>
        Tutti i contenuti (testi, immagini, loghi, grafica) presenti su questo siton
        sono di proprietà di B.A.S. D.O.C. SERIANA COBRAS o utilizzati con licenza. Ne è
        vietata la riproduzione senza autorizzazione.
      </p>

      <h2>2. Uso del sito</h2>
      <p>
        L’utente si impegna a utilizzare il sito in modo conforme alla legge e al buon
        senso, evitando comportamenti che possano danneggiare l’immagine o le attività
        dell’associazione.
      </p>

      <h2>3. Collegamenti esterni</h2>
      <p>
        Il sito può contenere link a siti esterni (es. Instagram, partner, sponsor).
        B.A.S. D.O.C. SERIANA COBRAS non è responsabile dei contenuti o delle politiche di
        tali siti.
      </p>

      <h2>4. Responsabilità</h2>
      <p>
        L’associazione non è responsabile di eventuali malfunzionamenti, errori o
        interruzioni del servizio.
      </p>

      <h2>5. Modifiche</h2>
      <p>
        B.A.S. D.O.C. SERIANA COBRAS si riserva il diritto di modificare i presenti termini
        in qualsiasi momento. Le modifiche avranno effetto dal momento della pubblicazione.
      </p>
    </main>
  );
}

export default Termini;